import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Panel } from 'primereact/panel';
import AddSuperProfileButton from './AddSuperProfileButton';

const i18nMessages = defineMessages({
  noSuperProfiles: {
    id: 'account.super-profiles.no-super-profiles',
    defaultMessage: 'There are currently no SuperProfiles',
  },
});

const NoSuperProfiles = () => {
  const { formatMessage } = useIntl();

  return (
    <div className="p-grid">
      <div className="p-col-12">
        <div className="brand-detailed-wrapper">
          <Panel>
            <div className="p-grid">
              <div className="p-col-12 align-right">
                <AddSuperProfileButton />
              </div>
              <div className="p-col-12 height-full">
                <div className="align-center vertical-align">
                  <h1>{formatMessage(i18nMessages.noSuperProfiles)}</h1>
                </div>
              </div>
            </div>
          </Panel>
        </div>
      </div>
    </div>
  );
};

export default NoSuperProfiles;
